import React, { useState } from 'react';
import SortButton from '../../UI/SortButton';

const FutureOpportunitiesTableHeader = () => {
  const [sortedBy, setSortedBy] = useState({
    title: null,
    agency: null
  });

  return (
    <tr>
      <SortButton 
        name="Opportunity/Contract"
        sortBy="title"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
      <th>
        Type
      </th>
      <SortButton 
        name="Agency"
        sortBy="agency"
        setSortedBy={setSortedBy}
        sortedBy={sortedBy}
      />
    </tr>
  )
}

export default FutureOpportunitiesTableHeader;